<template>
    <div class="role-item-list">
        <ul>
            <v-tag v-for="(role, index) in value" :key="role.role_id"
                class="role-item-tag"
                use-default-suf-icon
                :text="role.role_name"
                size="large"
                icon-fixed
                @sufAction="deleteRole(index)"
            />
        </ul>
        <template v-if="!disabled">
            <span v-if="value.length > 0" class="select-txt" @click="handleChange">修改</span>
            <span v-if="value.length === 0" class="select-txt" @click="handleChange">选择角色</span>
        </template>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    props: {
        value: {
            type: Array,
            default() {
                return [];
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    methods: {
        deleteRole(i) {
            const newVal = this.value.splice(i, 1);
            this.$emit('change', newVal);
        },
        handleChange() {
            this.$emit('handleChange');
        }
    }
};
</script>
<style lang="less">
@import './index.less';
</style>
